import config from "../../../_config/global";
import {
  IDeleteSingleArgs,
  IGetSingleArgs,
  IPageAndSearchArgs,
  IUpdateSingleArgs
} from "../../../interfaces";
import { goFetch } from "../../../utilities/goFetch";
import { linkedPartners, MainPrograms } from "../components";

interface apiResponse {
  data: Object;
  message?: string;
  success: boolean;
}
class Service {
  async getByPage({ search, pageNo }: IPageAndSearchArgs) {
    const awards = (await goFetch(config.endpoints.awards.getByPage)
      .withQueryParameters({
        search: search ?? "",
        pageSize: config.pageSize,
        pageNumber: pageNo || 1
      })
      .get()) as any;

    let { paginatedResults, totalCount } = awards?.data[0] || {};
    const itemCount = totalCount?.[0]?.count || 0;

    return {
      pageNo: pageNo,
      pageSize: config.pageSize,
      pageCount: Math.ceil(itemCount / config.pageSize),
      data: paginatedResults,
      itemCount
    };
  }

  async getTransferPartners(main_program: string): Promise<linkedPartners[]> {
    const main_programs = (await goFetch(
      config.endpoints.awards.getTransferPartners
    )
      .withQueryParameters({ main_program: main_program })
      .get()) as any;
    return main_programs.data;
  }

  async getMainPrograms(): Promise<MainPrograms[]> {
    const main_programs = (await goFetch(
      config.endpoints.awards.getMainPrograms
    )
      .withQueryParameters({ addDistinct: true })
      .get()) as any;
    return main_programs.data;
  }

  async getSingle({ key }: IGetSingleArgs) {
    const award = (await goFetch(`${config.endpoints.awards.getSingle}`)
      .withQueryParameters({ id: key })
      .get()) as unknown as apiResponse;

    return award.data;
  }

  async create() {
    return (await goFetch(
      `${config.endpoints.awards.add}`
    ).put()) as unknown as apiResponse;
  }

  async update({ key, ...rest }: IUpdateSingleArgs) {
    return goFetch(`${config.endpoints.awards.update}`)
      .withBody({
        _id: key,
        ...rest
      })
      .post() as unknown as apiResponse;
  }

  async delete(key: IDeleteSingleArgs) {
    await goFetch(`${config.endpoints.awards.delete}`)
      .withBody({ _id: key })
      .delete();
  }
}

export default new Service();
